import { AlertService } from './alert.service';

export const entities: any[] = [
  AlertService,
];

export * from './alert.service';
